export default function TableSkeleton({ rows = 6, columns = 5 }) {
  const widths = ["55%", "70%", "40%", "65%", "50%", "60%"];
  return (
    <div className="table-wrap" aria-busy="true" aria-label="Loading">
      <table className="tbl">
        <tbody>
          {Array.from({ length: rows }).map((_, r) => (
            <tr key={r}>
              {Array.from({ length: columns }).map((__, c) => (
                <td key={c}>
                  <span
                    style={{
                      display: "inline-block",
                      width: widths[(r + c) % widths.length],
                      height: 12,
                      borderRadius: 6,
                      background: "linear-gradient(90deg, var(--border) 0%, rgba(148,163,184,0.18) 50%, var(--border) 100%)",
                      backgroundSize: "200% 100%",
                      animation: "skeleton-pulse 1.4s ease-in-out infinite",
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <style>{`@keyframes skeleton-pulse { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }`}</style>
    </div>
  );
}

export function CardSkeleton({ height = 110 }) {
  return (
    <div
      style={{
        height,
        borderRadius: 16,
        background: "linear-gradient(90deg, var(--border) 0%, rgba(148,163,184,0.18) 50%, var(--border) 100%)",
        backgroundSize: "200% 100%",
        animation: "skeleton-pulse 1.4s ease-in-out infinite",
      }}
    />
  );
}
